import React from 'react'
import Tooltip from '../Material/Tooltip'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import GetAppIcon from '@material-ui/icons/GetApp'
import { withStyles } from '@material-ui/core/styles'

const styles = (theme) => ({
	wrapper: {
		float: 'right',
	},
	buttonText: {
		marginLeft: theme.spacing.unit,
	},
})

const ExportButton = ({ onClick, isExporting, actualCount, allowedCount, classes }) => {
	const toManyPoints = actualCount > allowedCount
	return (
		<React.Fragment>
			<Tooltip
				title = { toManyPoints ? `Du kan som mest exportera ${allowedCount} stompunkter i detta format.` : "" } 
				placement = "top"
			>
				<div className={classes.wrapper}>
					<Button 
						onClick = {onClick}
						className = {classes.button}
						color = "primary"
						variant = "contained"
						disabled = {isExporting || toManyPoints}
					>
						{ isExporting ? <CircularProgress size={24} color="inherit" /> : <GetAppIcon /> }
						<span className={classes.buttonText}>Exportera</span>
					</Button>
				</div>
			</Tooltip>
		</React.Fragment>
	)
}

export default withStyles(styles)(ExportButton)



// WEBPACK FOOTER //
// ./src/components/Export/ExportButton.js